import { Select, Skeleton } from 'antd'
import { useEffect, useState } from 'react';
import { Language } from '../../../models/Language';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { DEFAULT_LANGUAGE } from '../../../i18n/i18n';
import { UpdateAppLanguage } from '../../../RoutesApp';
import { useLocation } from 'react-router-dom';

import './LanguageSelectorComponent.scss';
import { GetArrowSelectIcon } from '../../../utils/icons';

const LanguageSelectorComponent = () : JSX.Element =>{

    const appConfig = useAppConfig();
    const location = useLocation();

    const [availableClientLanguages, setAvailableClientLanguages] = useState<Language[]>([]);

    const getAvailableClientLanguages = () : void => {
        if (appConfig && appConfig.config.availableLanguages){
            setAvailableClientLanguages(appConfig.config.availableLanguages);
        }
    }

    const changeLanguage = (shortCode: string) : void => {
        if (shortCode && shortCode.length > 0){
            UpdateAppLanguage(shortCode);
        }else{
            UpdateAppLanguage(DEFAULT_LANGUAGE);
        }
    }

    useEffect(()=>{
        getAvailableClientLanguages();
    },[appConfig])

    const urlSegment = location.pathname.split('/')[1]?.toLowerCase() ?? '';
    const matchedLanguage = availableClientLanguages.find(
        l => l.shortCode.toLowerCase() === urlSegment || l.iso.toLowerCase() === urlSegment
    );
    const selectedValue = matchedLanguage?.shortCode.toLowerCase() ?? DEFAULT_LANGUAGE;

    return (
        <>
            {
                availableClientLanguages && availableClientLanguages.length > 0
                ?
                    <Select className='language-selector' value={selectedValue} onChange={changeLanguage} suffixIcon={GetArrowSelectIcon()}>
                        {
                            availableClientLanguages.map((l: Language) => {
                                return <Select.Option disabled={!l.enabled} key={l.shortCode.toLowerCase()}>{l.description}</Select.Option>
                            })
                        }
                    </Select>
                :
                    <Skeleton.Input active size={'small'} />
            }
        </>
    )
}

export default LanguageSelectorComponent;